import { combineReducers } from 'redux';
import { TEMPLATE_LOAD, TEMPLATE_INIT_LOAD} from '../actions/types';
import moment from 'moment-timezone';
const timeZoneName = moment.tz.guess();
const Weeks = [ 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat','Sun'];
const initSlots = {
    '0':[{
        "start" :540,
        "end":1080
    }],
    '1':[{
        "start" :540,
        "end":780
    },{
        "start" :810,
        "end":1080
    }],
    '2':[{
        "start" :540,
       "end":1080
    }],
    '3':[{
        "start" :540,
        "end":1080
    }],
    '4':[{
        "start" :540,
        "end":1080
    }],
    '5':[],
    '6':[],
};
const initialState = {
    id :'',
    name: '',
    timezone:timeZoneName,
    slots: initSlots,
    holidays: [],
    showholidays:0,
    updatedat: "",
    updatedby:""
   
};
const setSlotConfig = (payloadData) => {

    Weeks.map((day, index) => {
        let timeSlotData = payloadData.slots[index];
        if (!timeSlotData) {
            payloadData.slots[index] =[];
        }
     });
 
 
    return payloadData;
}

export const templateForm = (state = initialState, action) => { 
    switch (action.type) {
        case TEMPLATE_LOAD:
            const payloadData = setSlotConfig(action.payload);
            return {
                ...state, ...payloadData
            }  
        case TEMPLATE_INIT_LOAD:
            return {
                ...initialState
            }
        default:
            return state
    }
}
export default templateForm;
